import { useOutletContext } from 'react-router-dom';
import type { ReferralDashboard, ReferralProgram } from '@zeroth/referral-contract';

export const SUPPORT_EMAIL = 'support@zerothhq.com';

export type PortalDashboard = ReferralDashboard & {
  partner: NonNullable<ReferralDashboard['partner']>;
  program: ReferralProgram;
};

export const percent = (basisPoints: number) => `${basisPoints / 100}%`;

/** The tier for a rate, from the program the API served. */
export function tierFor(program: ReferralProgram, rateBasisPoints: number) {
  return (
    program.tiers.find((tier) => tier.rateBasisPoints === rateBasisPoints) ?? {
      name: percent(rateBasisPoints),
      rateBasisPoints,
      minimumMonthlyCents: 0,
      requiresReview: false,
      qualification: '',
    }
  );
}

/** "20% off their first 3 paid months" */
export function customerOffer(program: ReferralProgram, whose = 'their') {
  const { basisPoints, paidMonths } = program.customerDiscount;
  return `${percent(basisPoints)} off ${whose} first ${paidMonths} paid month${paidMonths === 1 ? '' : 's'}`;
}

/** Builds an in-portal path; the portal is served at the root of partner.zerothhq.com. */
export const usePortalPath = () => (path = '') => '/' + path;

export const usePortalDashboard = () => useOutletContext<PortalDashboard>();
